import styled from "styled-components";

export const SelectViewTypeWrapper = styled.div`
    min-width: 165px;
`;